import * as TYPES from '../types';

const initialState = {
    projectList: [],
};

export function ProjectReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_PROJECT_SUCCESS:
            return {
                ...preState,
                projectList: payload,
            };

        default:
            return state;
    }
}